<template>
  <div>
    <div v-if="modal">
      <div class="modal-pdv show" :id="'modalPesquisa' + id" tabindex="-1" :class="{'modal-full': modal < 3}">
        <div :id="id" class="modal-pdv-content pt-0" v-if="modal === 1">
          <div class="container-fluid px-2 px-lg-0">
            <div class="row no-gutters">
              <div class="col-lg-4 px-2 pl-md-3 pt-3">
                <div class="mb-2 position-relative">
                  <div>
                    <input type="text" class="form-control pr-2" id="termProduto" placeholder="Pesquisar produto (Alt+P)"
                           v-model="term" @keydown.enter="selecionarProdutoPesquisa" @keydown.tab="$helpers.focusElement('btnItem0')">
                  </div>
                  <button v-show="!isSearching" class="btn btn-sm btn-help" @click="openAjuda()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-help" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#9454f0" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <circle cx="12" cy="12" r="9" />
                      <line x1="12" y1="17" x2="12" y2="17.01" />
                      <path d="M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4" />
                    </svg>
                  </button>
                  <button v-show="isSearching" class="btn btn-sm btn-help" @click="clearSearch(true)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M18 6l-12 12" />
                      <path d="M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                <div :class="{'d-mobile-none': stepFilter}" class="height-95 col-categorias border-right mb-0">
                  <div class="row no-gutters pr-md-2">
                    <div class="col-6 col-lg-4 mb-1 p-1" v-if="catalogos.length && user.id_funcao === '1'">
                      <a href="javascript:" class="btn btn-primary btn-block shadow-sm" @click="openModalCatalogo()" style="height: 90px; padding-top: 18px">
                        <div><icon-categoria name="catalogo" :light="true"/></div>
                        <span class="small">Catálogos</span>
                      </a>
                    </div>
                    <div class="col-6 col-lg-4 mb-1 p-1" v-if="user.status_fidelidade === '1'">
                      <a href="javascript:" class="btn btn-secondary btn-block shadow-sm" @click="openModalVoucher" style="height: 90px; padding-top: 18px">
                        <icon-categoria name="voucher" :light="true"  class="d-block"/>
                        <span class="small">Voucher</span>
                      </a>
                    </div>
                    <div class="col-6 col-lg-4 mb-1 p-1" v-for="t in termosRapidos">
                      <a class="btn btn-warning btn-block shadow-sm d-flex align-items-center" href="javascript:"
                         @click="pesquisarTermo({ valor: t.valor })" style="height: 90px; overflow: hidden">
                        <span class="small m-auto">{{t.nome_termo}}</span>
                      </a>
                    </div>
                    <div class="col-6 col-lg-4 mb-1 p-1" v-for="c in categorias">
                      <a :class="(!isSearching && pesquisa.id_categoria === c.id_categoria) ? 'btn-primary' : 'btn-light'" class="btn btn-block shadow-sm py-3 border" href="javascript:"
                         @click="filtrarCategoria(c)" style="height: 90px">
                        <icon-categoria :light="(!isSearching && pesquisa.id_categoria === c.id_categoria)" :name="c.slug ? c.slug : 'default'" class="d-block mb-2"/>
                        <span class="text-ellipsis small">{{c.nome_categoria}}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div id="listaProdutos" :class="{'d-mobile-none': !stepFilter}" class="col-lg-8" tabindex="-1">
                <div class="height-100 col-produtos pr-md-2">
                  <div class="row no-gutters" v-if="searchResults.length">
                    <div class="col-6 col-sm-4 col-xl-3 p-2 product" v-for="(r,index) in searchResults" :key="index" :class="{'selected': r.quantidade}">
                      <div class="p-2 border rounded shadow-sm overflow-hidden product-body">
                        <div class="mb-2 pointer" @click="toggleProduto(r)">
                          <div class="clearfix">
                            <img class="img-produto img-pizza" :class="'tamanho-' + r.id_tabela" :src="require(`../../../assets/imgs/pizza_${r.divisao}.png`)" v-if="r.divisao > 0">
                            <img class="img-produto" alt="Img Produto" :src="r.img_produto" v-else-if="r.img_produto">
                            <a href="javascript:" :id="'btnItem' + index"
                               @keydown.tab="$helpers.focusElement('btnItem' + (index + 1))"
                               class="d-block small text-produto text-decoration-none font-weight-bold">
                              {{r.nome_produto}}
                            </a>
                          </div>
                          <div class="badge badge-primary mr-1" :class="{'invisible': r.valor <= 0}">R$ {{r.valor}}</div>
                          <div class="badge badge-success" v-if="r.estoque && r.estoque.qtd < 1000">
                            <span v-if="r.estoque.qtd > 0"><i class="fa fa-box-open"></i> {{ r.estoque.qtd}}</span>
                            <span v-else>Sem estoque</span>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between border rounded text-center text-nowrap" v-if="id_edit && id_edit.id === r.id_tabela_preco">
                          <button class="btn" @click="toggleQtd(r, true)">
                            <i class="fa fa-times" style="width: 12px"></i>
                          </button>
                          <div style="padding: 6px; max-width: 72px">
                            <input class="form-control text-center" type="tel" :id="`iptQtd${index}`" v-model="id_edit.qtd"
                                   @blur="cancelQtd(r)" @keyup.enter="toggleQtd(r)" @keydown.esc.prevent="toggleQtd(r, true)"/>
                          </div>
                          <button class="btn" @click="toggleQtd(r)">
                            <i class="fa fa-check" style="width: 12px"></i>
                          </button>
                        </div>
                        <div class="d-flex justify-content-between border rounded text-center text-nowrap" v-else>
                          <button class="btn" @click="removerProduto(r)">
                            <i class="fa fa-minus" style="width: 12px"></i>
                          </button>
                          <div class="font-weight-bold pointer" style="padding: 6px 22px;" @click="editarQtd(r, index)">{{ r.quantidade }}</div>
                          <button class="btn" @click="adicionarProduto(r)">
                            <i class="fa fa-plus" style="width: 12px"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="isSearching" class="text-center center mt-5">
                    <i class="fa fa-frown fa-2x padding"></i>
                    <div class="mt-2">Não encontrado resultados!</div>
                  </div>
                  <div v-else class="text-center center mt-5">
                    <i class="fa fa-tags padding"></i>
                    <div class="mt-2">Selecione uma categoria ou pesquise um produto</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-content-footer bg-light p-2 mt-2 border-top d-flex justify-content-between">
            <button class="btn btn-dark p-3" @click="voltarProduto()">
              <i class="fa fa-chevron-left mr-2"></i>
              <span>Voltar</span>
            </button>
            <button class="btn btn-success p-3" @click.prevent="adicionar()">
              {{lista.length ? 'Adicionar' : 'Avançar'}}
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>

        <div v-if="modal === 2" class="modal-pdv-content pt-0">
          <div class="container-fluid px-2 px-lg-0 pt-3">
            <div class="row no-gutters">
              <div class="col-md-2 mb-2 d-none d-md-block">
                <div class="px-2 pl-md-3">
                  <span class="font-weight-bold small">Produto:</span>
                  <div>{{dados.produto.nome_produto}}</div>
                </div>
              </div>
              <div class="col-md-10">
                <div class="mb-2 px-2" style="position: relative" v-if="modal === 2">
                  <input type="text" class="form-control" id="termDivisao" placeholder="Pesquisar divisão"
                         v-model="termDivisao" @keyup="handleDivisoes()" @keydown.enter="selecionarDivisaoEnter">
                </div>
                <div class="height-95 col-divisoes pr-md-2">
                  <div class="row no-gutters" v-if="searchDivisoes.length">
                    <div class="col-6 col-md-4 col-xl-3 p-2" v-for="r in searchDivisoes" @click="selecionarDivisao(r)">
                      <a href="javascript:" class="text-dark text-decoration-none">
                        <div class="px-2 pt-2 border rounded shadow-sm overflow-hidden" :class="r.selected ? 'text-white bg-primary' : 'bg-light'" style="height: 100px">
                          <div class="small text-produto">
                            <span v-if="r.ref_produto">{{r.ref_produto + ' - '}}</span> {{r.nome_produto}}
                          </div>
                          <div class="text-right">
                            <div class="badge badge-primary" v-show="r.valor > 0">R$ {{r.valor}}</div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="text-center center mt-5" v-else>
                    <i class="fa fa-frown padding"></i> Não encontrado resultados!
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-content-footer bg-light p-2 mt-2 border-top d-flex justify-content-between">
            <button class="btn btn-dark p-3" @click="voltarDivisao">
              <i class="fa fa-chevron-left mr-2"></i>
              <span>Voltar</span>
            </button>
            <button class="btn btn-success p-3" @click="avancarDivisao">
              Avançar
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>

        <div class="modal-pdv-content" id="modalPeso" v-if="modal === 3">
          <div class="container-fluid">
            <div class="d-flex justify-content-between mb-3 mt-2">
              <money v-bind="iptPeso" :id="input" class="form-control mr-2" @keyup.enter.native="selecionarkilo()" v-model="valorPeso"/>
              <div class="text-nowrap">
                <button class="btn btn-success px-4 mr-1" @click="selecionarkilo()" :disabled="inseriuPeso">
                  <i class="fa fa-plus"></i>
                </button>
                <button class="btn btn-third" @click="lerPeso()">
                  <i class="fa fa-tachometer-alt mr-1"></i> Pesar (P)
                </button>
              </div>
            </div>
            <div class="alert alert-info">
              <i class="fa fa-info-circle mr-1"></i> <span class="small">Aperte a tecla (Enter) para adicionar ou (F) para finalizar</span>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3 mb-md-0">
                <ul class="list-group">
                  <li class="list-group-item">{{dados.produto ? dados.produto.nome_produto : ''}} <span class="ml-1">({{(dados.produto ? dados.produto.valor : 0) | valor}})</span></li>
                  <li class="list-group-item">Qtd:
                    <b v-if="optkg === 1">{{valorPeso / (dados.produto && dados.produto.valor > 0 ? dados.produto.valor : 1) | medida}}</b>
                    <b v-else>{{valorPeso | medida}}</b>
                  </li>
                  <li class="list-group-item">
                    Total:
                    <b v-if="optkg === 1">{{valorPeso | valor}}</b>
                    <b v-else>{{valorPeso * (dados.produto ? dados.produto.valor : -1) | valor}}</b>
                  </li>
                </ul>
              </div>
              <div class="col-md-6">
                <div class="border height-50 mb-2 rounded" style="min-height: 180px!important;">
                  <table class="table table-sm table-striped">
                    <tr class="small bg-light">
                      <th class="text-center">Quantidade</th>
                      <th class="text-center" style="width: 50%">Valor</th>
                      <th class="text-center" style="width: 32px">&nbsp;</th>
                    </tr>
                    <tbody>
                      <tr v-for="(l, index) in lista">
                        <td class="text-center">{{ l.quantidade | medida }}</td>
                        <td class="text-center">{{ l.valor_total | valor }}</td>
                        <td class="text-center">
                          <button class="btn btn-sm text-danger" @click="remover(null, index)"><i class="fa fa-trash-alt"></i></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-content-footer bg-light p-2 mt-2 border-top d-flex justify-content-between">
            <button class="btn btn-dark p-3" @click="voltarPeso()">
              <i class="fa fa-chevron-left mr-2"></i>
              <span>Voltar</span>
            </button>
            <button class="btn btn-success p-3" @click.prevent="adicionar()">
              Adicionar <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>

        <div class="modal-pdv-content" id="modalVoucher" v-if="modal === 5">
          <div class="container-fluid">
            <h6 class="text-center font-weight-bold mb-2">Informe o Voucher</h6>
            <div class="d-flex mb-3 align-items-center">
              <span class="font-weight-bold mr-2 text-nowrap">B -</span>
              <input :id="'voucher' + input" placeholder="######" type="tel" class="form-control" @keyup.enter="addVoucher(true)" v-model="ref_voucher"/>
              <button class="btn btn-info ml-1 text-nowrap" @click="addVoucher(true)">
                <i class="fa fa-search"></i>
              </button>
            </div>
            <div v-if="voucher.id_voucher">
              <div class="alert alert-success mb-2">
                <h6 class="font-weight-bold mb-2">Voucher válido</h6>
                <div class="small">
                  <div><b>Benefício:</b> {{ voucher.titulo }}</div>
                  <div><b>Expiração:</b> {{ voucher.data_expiracao }} | <b>Pontos:</b> {{ voucher.pontos }}</div>
                  <div><b>Cliente:</b> {{ voucher.nome_cliente }}</div>
                  <div><b>Empresa:</b> {{ voucher.nome_fantasia }}</div>
                </div>
              </div>
            </div>
            <div class="alert alert-warning mb-3" v-if="voucher.msg">
              <h6 class="font-weight-bold mb-1">Ops! temos um problema.</h6>
              <div class="small">{{voucher.msg}}</div>
              <div v-if="voucher.id_comanda">
                Venda: {{voucher.id_comanda}}. <a href="javascript:" class="text-primary font-weight-bold small" @click="acessarVenda(voucher.id_comanda)">Acessar venda</a>
              </div>
            </div>
          </div>
          <div class="modal-content-footer bg-light p-2 mt-2 border-top d-flex justify-content-between">
            <button class="btn btn-dark p-3" @click="closeModal">
              <i class="fa fa-chevron-left mr-2"></i>
              <span>Voltar</span>
            </button>
            <button class="btn btn-success p-3" @click="addVoucher()" :disabled="!ref_voucher.trim()" v-if="voucher.id_voucher">
              Adicionar voucher
            </button>
          </div>
        </div>

        <div class="modal-pdv-content" v-if="modal === 6">
          <div class="container-fluid">
            <h6 class="text-center font-weight-bold">Selecione um catálogo</h6>
            <hr>
            <div class="row no-gutters">
              <div class="col-12 col-md-6 px-1 mb-2">
                <a href="javascript:" class="btn btn-block shadow-sm py-3 border btn-catalogo" :class="{'btn-primary': !id_catalogo}" @click="toggleCardapio()">
                  <div><icon-categoria name="catalogo" :light="!id_catalogo"/><i class="fa fa-check-circle ml-1" v-show="!id_catalogo"></i></div>
                  <span class="small">Default (Loja)</span>
                </a>
              </div>
              <div class="col-12 col-md-6 px-1 mb-2" v-for="c in catalogos">
                <a href="javascript:" class="btn btn-block shadow-sm py-3 border btn-catalogo" :class="{'btn-primary': id_catalogo === c.id_catalogo}" @click="toggleCardapio(c)">
                  <div><icon-categoria name="catalogo" :light="id_catalogo === c.id_catalogo"/><i class="fa fa-check-circle ml-1" v-show="id_catalogo === c.id_catalogo"></i></div>
                  <span class="small">{{c.nome_catalogo}}</span>
                </a>
              </div>
            </div>
          </div>
          <div class="modal-content-footer bg-light p-2 mt-2 border-top d-flex justify-content-between">
            <button class="btn btn-dark p-3" @click="closeModal">
              <i class="fa fa-chevron-left mr-2"></i>
              <span>Voltar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <adicionais ref="adicionais" @voltar="voltarAdicionais" @retornar="retornarDados"/>
  </div>
</template>

<script>
  import IconCategoria from '../../../components/pdv/IconCategoria'
  import Adicionais from "./Adicionais";
  import ModalMenu from "@/components/commons/ModalMenu";
  import IconSys from "@/components/pdv/IconSys";

  export default {
    name: "PesquisarProduto",
    components: {IconSys, ModalMenu, Adicionais, IconCategoria},
    props: ['pdv'],
    data() {
      return {
        token: localStorage.getItem('key'),
        modal: null,
        id: this.$helpers.ID(),
        term: '',
        termDivisao: '',
        produtosDivisao: [],
        gruposAds: [],
        produtos: [],
        pesquisa: { id_categoria: '' },
        input: '',
        isMobile: false,

        dados: {
          produto: {},
          divisoes: [],
          adicionais: [],
          quantidade: 1,
          desconto: 0,
          observacao: '',
          valor_total: 0
        },

        lista:[],

        valorPeso: 0,
        iptPeso: {
          decimal: '.',
          thousands: '',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },

        searchDivisoes: [],

        menus: [{ nome: 'Valor', active: true }, { nome: 'Kilo', active: true }],
        optkg: 1,
        inseriuPeso: false,
        timeOutBalanca: null,

        voucher: { msg: null },
        ref_voucher: '',
        id_edit: null,
      }
    },

    methods: {
      toggleModal(modal, callback) {
        this.modal = modal;
        this.$nextTick(() => {
          this.$helpers.toggleModal(modal, 'modalPesquisa' + this.id, this.closeModal);

          if (modal) {
            const elModal = document.getElementById(this.id);

            if (elModal) {
              elModal.scrollTop = 0
            }
          }

          if (callback) {
            callback();
          }
        });
      },

      closeModal() {
        switch (this.modal) {
          case 1:
          case 3:
            this.voltarProduto();
            break;
          case 2:
            this.voltarDivisao();
            break;
          case 5:
          case 6:
            this.modal = 1;
            this.$nextTick(() => {
              this.$helpers.focusElement('termProduto');
            });
            break;
        }
      },

      clearSearch(focus) {
        this.term = "";
        this.pesquisa.id_categoria = !this.isMobile && this.categorias.length ? this.categorias[0].id_categoria : null;

        if (focus) {
          this.$helpers.focusElement('termProduto');
        }
      },

      selecionarProdutoPesquisa() {
        if (!this.is_mobile) {
          if (this.searchResults.length === 1) {
            this.toggleProduto(this.searchResults[0]);

          } else if (this.searchResults.length) {
            this.$helpers.focusElement('listaProdutos');
          }
        }
      },

      handleDivisoes() {
        if (this.termDivisao.trim()) {
          this.searchDivisoes = this.produtosDivisao.filter(p => p.normalized.includes(this.termDivisao.toLowerCase()));

        } else {
          this.searchDivisoes = this.produtosDivisao;
        }
      },

      pesquisarTermo(pesquisa) {
        const termo = pesquisa || {};
        this.dados.quantidade = termo && termo.quantidade && parseInt(termo.quantidade) > 0 ? termo.quantidade : 1;

        if (termo.valor) {
          this.term = termo.valor;

          if (termo.categoria) {
            this.pesquisa.id_categoria = termo.categoria ? termo.categoria : '';
          }
        }

        this.$helpers.focusElement(termo.categoria ? 'listaProdutos' : 'termProduto');
      },

      filtrarCategoria(c) {
        this.term = "";
        const id_categoria = c?.id_categoria || null;
        this.pesquisa.id_categoria = this.pesquisa.id_categoria !== id_categoria ? id_categoria : null;
        this.$helpers.scrollTop(this.id);

        if (!this.isMobile) {
          this.$helpers.focusElement('listaProdutos');
        }
      },

      limparSearch(id) {
        this.$helpers.focusElement(id);
        this.term = "";
      },

      toggleProduto(produto) {
        const r = this.lista.find(l => l.id_tabela_preco === produto.id_tabela_preco);

        if (r) {
          produto.quantidade = 0;
          this.remover(r);

        } else {
          this.adicionarProduto(produto, false, false, r);
        }
      },

      editarQtd(r,index) {
        this.id_edit = { id: r.id_tabela_preco, qtd: r.quantidade };
        this.$nextTick(() => { this.$helpers.selectElement(`iptQtd${index}`) });
      },

      cancelQtd(r) {
        setTimeout(() => {
          if (this.id_edit) {
            this.toggleQtd(r, true);
          }

          this.id_edit = null;
        }, 500);
      },

      toggleQtd(produto, cancel) {
        const qtd = cancel ? (produto.quantidade || 0) : (this.id_edit ? this.id_edit.qtd : 0);
        const r = this.lista.find(l => l.id_tabela_preco === produto.id_tabela_preco);

        if (isNaN(qtd) || qtd <= 0 || qtd > 1000000) {
          produto.quantidade = 0;
          this.remover(r);

        } else {
          this.adicionarProduto(produto, false, false, r, qtd);
        }

        this.id_edit = null;
      },

      async adicionarProduto(produto, finalizar, voucher, rList, qtd) {
        const r = rList || this.lista.find(l => l.id_tabela_preco === produto.id_tabela_preco);

        if (r && !voucher) {
          qtd = qtd ? parseInt(qtd) : (r.quantidade + 1);

          if (r.estoque && qtd > r.estoque.qtd) {
            produto.quantidade = r.quantidade;
            this.$swal("Estoque máximo: " + r.estoque.qtd.toFixed());
            return;
          }

          r.quantidade = qtd;
          produto.quantidade = r.quantidade;
          this.totalizarProduto(r);

        } else {
          const dados = {
            id_tabela_preco: produto.id_tabela_preco || null,
            produto: {},
            divisoes: [],
            adicionais: [],
            quantidade: qtd || 1,
            desconto: 0,
            observacao: '',
            valor_total: 0,
          };

          if (this.req_estoque) {
            await this.consultarEstoque(dados, produto);

            if (dados.estoque && dados.quantidade > dados.estoque.qtd) {
              this.$swal(dados.estoque.qtd > 0 ? ("Estoque máximo: " + dados.estoque.qtd.toFixed()) : "Produto sem estoque");
              return;
            }
          }

          if (voucher && voucher.id_voucher) {
            dados.id_voucher = voucher.id_voucher;
            dados.voucher = voucher;
          }

          dados.produto = {
            id_tabela_preco: produto.id_tabela_preco,
            nome_produto: produto.nome_produto,
            id_produto: produto.id_produto,
            valor: produto.valor,
            valor_custo: produto.valor_custo,
            id_medida: produto.id_medida,
            tipo_venda: produto.tipo_venda,
            divisao: produto.divisao,
            adicionais: produto.adicionais.length > 0
          };

          if (parseInt(produto.id_medida) === 2) {
            dados.quantidade = 0;

            if (this.dados.quantidade !== 1) {
              dados.quantidade = this.optkg === 2 ? (parseFloat(this.dados.quantidade) / 1000) : parseFloat(this.dados.quantidade);
              this.valorPeso = dados.quantidade;
            }

            this.dados = dados;
            this.dados.adicionais = [];

            if (!this.modal) {
              this.toggleModal(3, () => {
                this.escutarEventoPeso();
              });

            } else {
              this.modal = 3;
              this.$nextTick(() => {
                this.escutarEventoPeso();
              });
            }

            return;
          }

          if (produto.divisao && parseInt(produto.divisao)) {
            this.dados = dados;
            this.produtosDivisao = (produto.divisoes || []).map(d => { return { ...d, selected: false } });
            this.termDivisao = '';
            this.handleDivisoes();

            if (!this.modal) {
              this.toggleModal(2, () => {
                this.clearDivisao(!this.is_mobile);
              });

            } else {
              this.modal = 2;
              this.$nextTick(() => {
                this.$helpers.focusElement('termDivisao');
              });
            }

            return;
          }

          if (produto.adicionais.length) {
            this.dados = dados;
            this.$refs.adicionais.openAdicionais(produto.adicionais);
            return;
          }

          produto.quantidade = dados.quantidade;
          this.retornarDados(null, dados, finalizar);
        }
      },

      removerProduto(produto) {
        const r = this.lista.find(l => l.id_tabela_preco === produto.id_tabela_preco);

        if (r) {
          r.quantidade = r.quantidade === 1 ? 0 : (r.quantidade - 1);
          produto.quantidade = r.quantidade;

          if (r.quantidade === 0) {
            this.remover(r);

          } else {
            this.totalizarProduto(r);
          }

          produto.quantidade = r.quantidade;
        }
      },

      totalizarProduto(p) {
        let valor = parseFloat(p.produto.valor);

        if (p.divisoes.length > 0) {
          valor = p.produto.tipo_venda === '2' ?
              (p.divisoes.map(d => parseFloat(d.valor)).reduce((prev, curr) => prev + curr, 0) / p.divisoes.length)
              : Math.max.apply(Math, p.divisoes.map(d => { return d.valor; }));
        }

        let valorAdicionais = 0;
        p.adicionais.forEach((a) => {
          valorAdicionais += a.valor * a.quantidade
        });

        p.valor_total = ((valor + valorAdicionais) * p.quantidade) - p.desconto;
      },

      async consultarEstoque(dados, produto) {
        this.$store.state.load = 'Buscando estoque';
        const params = { id: dados.id_tabela_preco, id_catalogo: this.id_catalogo }
        await this.$http.get('produto/estoque/preco/' + this.token, { params })
          .then(response => {
            this.$store.state.load = false;
            const estoque = response.data || null;

            if (estoque) {
              estoque.qtd = parseInt(estoque.qtd || '0');
              dados.estoque = { qtd: estoque.qtd };
              produto.produto = { qtd: estoque.qtd };
              produto.estoque = { qtd: estoque.qtd }
            }

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      retornarDados(adicionais, produto, finalizar) {
        let dados = produto ? produto : this.dados;
        let valor = 0.00;
        dados.adicionais = [];

        if (adicionais) {
          dados.adicionais = adicionais.map(a => { return {
            id_grupo_adicional: a.id_grupo_adicional,
            id_tabela_preco: a.id_tabela_preco,
            nome_produto: a.nome_produto,
            quantidade: a.quantidade,
            valor_custo: a.valor_custo || 0,
            valor: a.valor
          }});
        }

        if (dados.divisoes.length > 0) {
          valor = dados.produto.tipo_venda === '2' ?
              (dados.divisoes.map(d => parseFloat(d.valor)).reduce((prev, curr) => prev + curr, 0) / dados.divisoes.length)
              : Math.max.apply(Math, dados.divisoes.map(d => { return d.valor; }));
          valor = (dados.produto.valor > 0 ? parseFloat(dados.produto.valor) : 0) + valor;
          dados.produto.valor = valor;
          finalizar = true;

        } else {
          valor = parseFloat(dados.produto.valor);
        }

        dados.valor_total = (valor * dados.quantidade) - dados.desconto;
        dados.adicionais.forEach((a) => {
          dados.valor_total += (a.valor * a.quantidade)
        });

        if (dados.valor_total < 0) {
          return;
        }

        this.lista.push(dados);

        if (!this.modal || finalizar) {
          this.adicionar();

        } else {
          this.modal = 1;

          if (!produto) {
            produto = this.produtos.find(p => p.id_tabela_preco === dados.id_tabela_preco);

            if (!produto) {
              this.$swal("Erro ao selecionar o produto.");
              return;
            }
          }

          produto.quantidade = dados.quantidade;

          if (adicionais) {
            this.$helpers.focusElement('termProduto');
          }
        }
      },

      remover(p, index) {
        if (index !== undefined) {
          this.lista.splice(index, 1);

        } else if (p) {
          this.lista = this.lista.filter(l => l.id_tabela_preco !== p.id_tabela_preco);
        }
      },

      adicionar(finalizar) {
        this.toggleModal(null);
        this.$emit('atualizarPedidos', this.lista, finalizar);
      },

      selecionarDivisaoEnter() {
        if (!this.is_mobile && this.searchDivisoes.length === 1) {
          this.selecionarDivisao(this.searchDivisoes[0]);
        }
      },

      selecionarDivisao(produto) {
        if (this.dados.divisoes.find(d => d.id_tabela_preco === produto.id_tabela_preco)) {
          this.removerDivisao(produto);
          return;
        }

        if (this.dados.divisoes.length < this.dados.produto.divisao) {
          produto.selected = true;
          this.dados.divisoes.push({
            id_tabela_preco: produto.id_tabela_preco,
            nome_produto: produto.nome_produto,
            valor_custo: produto.valor_custo,
            valor: produto.valor
          });

          if (this.dados.divisoes.length < this.dados.produto.divisao) {
            if (this.termDivisao.length) {
              this.clearDivisao(true);
            }

          } else {
            this.$store.state.load = "Avançando..";

            setTimeout(() => {
              this.$store.state.load = false;
              this.avancarDivisao();
            }, 500);
          }

        } else {
          this.$swal("Atenção!", "Máximo de divisões permitidas: " + this.dados.produto.divisao);
        }
      },

      clearDivisao(focus) {
        this.termDivisao = '';
        this.searchDivisoes = this.produtosDivisao;

        if (focus) {
          this.$helpers.focusElement("termDivisao");
        }
      },

      avancarDivisao() {
        if (this.dados.divisoes.length === parseInt(this.dados.produto.divisao)) {
          if (this.dados.produto.adicionais) {
            const produto = this.produtos.find(p => p.id_tabela_preco === this.dados.id_tabela_preco);
            this.$refs.adicionais.openAdicionais(produto ? produto.adicionais : []);
            return;
          }

          this.retornarDados(null, null);

        } else {
          this.$swal("Atenção!", "Você precisa selecionar todos os sabores!")
        }
      },

      escutarEventoPeso() {
        this.$helpers.selectElement(this.input);
        const modal = document.getElementById('modalPeso');

        if (modal) {
          modal.addEventListener('keydown', (e) => {
            if (e.key === 'p') {
              this.lerPeso();

            } else if (e.key === 'f') {
              this.adicionar(true);
            }
          });
        }
      },

      lerPeso() {
        if (this.$store.state.load) {
          return;
        }

        if (!this.isElectron) {
          this.$swal('Por favor, instale o Gestor LeCard para usar a integração com a balança.').then(() => {
            this.$helpers.focusElement(this.input);
          });

          return;
        }

        this.$store.state.load = "Fazendo a leitura da balança";

        this.timeOutBalanca = setTimeout(() => {
          this.$store.state.load = false;
          this.$swal('Não foi possível fazer a leitura').then(() => {
            this.$helpers.focusElement(this.input);
          });
        }, 7000);

        document.dispatchEvent(new CustomEvent('comandoAcbr', { detail: "BAL.LePeso" }));
      },

      changeOptKg(m, notFocus) {
        this.iptPeso.prefix = m === 1 ? 'R$ ' : 'Kg: ';
        this.iptPeso.precision = m === 1 ? 2 : 3;
        this.optkg = m;
        this.valorPeso = 0;

        if (!notFocus) {
          this.$helpers.focusElement(this.input);
        }
      },

      selecionarkilo() {
        if (this.inseriuPeso) {
          return;
        }

        const valor_produto = (this.dados.produto && this.dados.produto.valor > 0 ? this.dados.produto.valor : 0);

        if (valor_produto <= 0) {
          return;
        }

        let qtd = this.optkg === 1 ? (this.valorPeso / valor_produto) : this.valorPeso;
        let valor_total = this.optkg === 1 ? this.valorPeso : (this.valorPeso * valor_produto);

        if (qtd > 0) {
          this.dados.quantidade = parseFloat(qtd).toFixed(3);
          this.dados.valor_total = valor_total;
          this.valorPeso = 0;
          this.inseriuPeso = true;
          this.lista.unshift(Object.assign({generatedId: this.$helpers.ID()}, this.dados));

          this.$store.state.load = "Inserindo dados..";
          setTimeout(() => {
            this.$store.state.load = false;
            this.inseriuPeso = false;
            this.$helpers.focusElement(this.input, true);
          }, 500);

        } else if (this.lista.length) {
          this.adicionar();
        }
      },

      removerDivisao(divisao) {
        divisao.selected = false;
        this.dados.divisoes = this.dados.divisoes.filter((d) => d.id_tabela_preco !== divisao.id_tabela_preco);
      },

      voltarPeso() {
        if (this.lista.length) {
          this.$swal({
            text: 'Atenção, os itens pesados serão descartados.\nDeseja continuar?',
            buttons: ['Não', 'Sim']
          }).then((res) => {
            if (res) {
              this.voltarProduto();
            }
          });

        } else {
          this.voltarProduto();
        }
      },

      voltarProduto() {
        if (this.isMobile && this.stepFilter) {
          this.clearSearch();
          this.$helpers.scrollTop(this.id);

        } else {
          this.$emit('cancelar');
          this.toggleModal(null);
          this.$helpers.focusElement(this.pdv ? 'pesquisar' : 'pesquisaPedido');
        }
      },

      voltarDivisao() {
        this.produtosDivisao = [];
        this.searchDivisoes = [];
        this.modal = 1;
        this.$emit('cancelar');
      },

      voltarAdicionais() {
        if (this.dados.produto && this.dados.produto.divisao > 0) {
          this.toggleModal(2, () => {
            this.clearDivisao(!this.is_mobile);
          });

        } else {
          if (this.modal) {
            this.toggleModal(1, () => {
              this.$helpers.focusElement(this.pesquisa.id_categoria ? 'listaProdutos' : 'termProduto')
            });

          } else {
            this.$helpers.focusElement(this.pdv ? 'pesquisar' : 'pesquisaPedido');
          }
        }
      },

      acbrReply(e) {
        clearTimeout(this.timeOutBalanca);
        this.$store.state.load = false;

        if (e.detail && e.detail.startsWith('OK:')) {
          const kilo = parseFloat(e.detail.replace('OK:','').trim().replace(',','.'));

          if (!isNaN(kilo) && kilo > 0) {
            const valor_produto = (this.dados.produto && this.dados.produto.valor > 0 ? this.dados.produto.valor : -1);
            this.valorPeso = this.optkg === 1 ? (valor_produto * kilo.toFixed(3)).toFixed(2) : kilo.toFixed(3);
            this.selecionarkilo();
          }

        } else if (e.detail) {
          this.$swal(e.detail).then(() => {
            this.$helpers.focusElement(this.input);
          })
        }
      },

      openAjuda() {
        const text = `Pesquisa dinâmica: após a busca, você pode navegar entre os produtos usando a tecla “TAB”. Para confirmar o item selecionado aperte a tecla “ENTER”.
        Atalhos do Sistema:
        001 - Produto diversos
        002 - Taxa de Entrega`;
        this.$swal(text).then(() => {
          this.$helpers.focusElement('termProduto');
        });
      },

      openModalVoucher() {
        this.voucher = {};
        this.ref_voucher = '';
        this.modal = 5;
        this.$nextTick(() => {
          this.$helpers.focusElement('voucher' + this.input);
        });
      },

      addVoucher(validar) {
        if (this.voucher.id_voucher && !validar) {
          const produto = this.produtos.find(p => p.id_tabela_preco === this.voucher.id_tabela_preco);

          if (produto) {
            this.adicionarProduto(produto, true, this.voucher);

          } else {
            this.toggleModal(null);
            this.$emit('addVoucher', this.voucher, true);
          }

          return;
        }

        this.ref_voucher = this.ref_voucher ? this.ref_voucher.replace(/[^\d]/g, '') : '';

        if (!this.ref_voucher.trim() || isNaN(this.ref_voucher)) {
          this.$swal("Por favor informe apenas números no código do Voucher").then(() => {
            this.$helpers.focusElement('voucher' + this.input);
          });

          return;
        }

        this.$store.state.load = "Validando Voucher";
        this.voucher = { msg: null };

        this.$http.post('voucher/validar/' + this.token, { voucher: this.ref_voucher, is_produto: 'true' })
          .then(res => {
            this.$store.state.load = false;

            if (res.data.result && res.data.dados && res.data.dados.id_tabela_preco) {
              this.voucher = { ...res.data.dados, msg: res.data.msg };

            } else {
              this.voucher.msg = res.data.msg || 'Este Benefício não está mais disponível!'
              this.voucher.id_comanda = res.data.id_comanda || null
            }

          }, res => {
            this.$store.state.load = false;
            this.voucher.msg = res.data.msg || 'Erro temporário'
          });
      },

      openModalCatalogo() {
        this.modal = 6;
      },

      toggleCardapio(c) {
        this.$swal({
          text: "Atenção, os itens da venda que não estiverem salvados serão removidos, deseja continuar?",
          dangerMode: true,
          buttons: ["Não", "Sim"]
        }).then((res) => {
          if (res) {
            if (c) {
              localStorage.setItem('catalogo', c.id_catalogo);

            } else {
              localStorage.removeItem('catalogo');
            }

            window.location.reload();
          }
        });
      },

      acessarVenda(id) {
        this.$swal({
          text: 'Atenção, ao acessar essa venda você poderá perder todos os dados não salvos. Deseja continuar?',
          buttons: ['Não', 'Sim']
        }).then((res) => {
          if (res) {
            this.toggleModal(false);

            if (this.$route.path !== '/pdv/' + id) {
              this.$router.push('/pdv/' + id);
            }
          }
        })
      },

      pesquisarProduto(pesquisa, sel, callback) {
        this.changeOptKg(parseInt(this.$store.state.pdv.unidade_medida || '1'), true);

        if (this.modal) {
          this.clearSearch(true);
          return;
        }

        this.produtos = JSON.parse(JSON.stringify(this.cacheProdutos || []));
        this.lista = [];
        this.valorPeso = 0;
        this.termDivisao = "";
        this.dados = {
          produto: {},
          divisoes: [],
          adicionais: [],
          quantidade: 1,
          desconto: 0,
          observacao: '',
          valor_total: ''
        };

        this.clearSearch();
        const termo = pesquisa || {};
        this.dados.quantidade = termo.quantidade && parseInt(termo.quantidade) > 0 ? termo.quantidade : 1;

        if (sel && termo.valor) {
          const produto = this.produtos.find(p => p.ref_produto === termo.valor);

          if (produto) {
            this.adicionarProduto(produto, true, false, false, this.dados.quantidade);

          } else {
            if (callback) callback(false);
          }

        } else {
          this.toggleModal(1, () => {
            if (termo.valor && termo.valor.trim() && this.user.status_fidelidade === '1' && termo.valor.toLowerCase().startsWith('b-')) {
              this.openModalVoucher();
              this.ref_voucher = termo.valor;
              this.addVoucher(true);

            } else {
              this.pesquisarTermo(termo);
            }
          });
        }
      },

      closePesquisar() {
        this.modal = null;
      }
    },

    mounted() {
      this.isMobile = window.innerWidth <= 991;
      document.addEventListener("acbrReply", this.acbrReply, false);
    },

    created() {
      this.input = this.$helpers.ID();
    },

    computed: {
      isSearching() {
        return !!this.term.trim();
      },

      stepFilter() {
        return this.isSearching || this.pesquisa.id_categoria;
      },

      categorias() {
        return this.$store.state.categorias
      },

      cacheProdutos() {
        return this.$store.state.produtos
      },

      searchResults() {
        let lista = this.produtos;
        const term = this.term.trim().toLowerCase();

        if (term) {
          return lista.filter(p => p.normalized && p.normalized.includes(term));

        } else {
          const idCategoria = this.pesquisa.id_categoria;

          if (idCategoria) {
            return lista.filter(p => p.id_categoria === idCategoria);
          }
        }

        return [];
      },

      divisoes() {
        return this.$store.state.divisoes
      },

      termosRapidos() {
        return this.$store.state.termosRapidos
      },

      user() {
        return this.$store.state.dataUser
      },

      catalogos() {
        return this.$store.state.catalogos;
      },

      id_catalogo() {
        return this.$store.state.id_catalogo;
      },

      req_estoque() {
        return this.$store.state.req_estoque;
      }
    },

    filters: {
      medida(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(3) + " kg";
        }
      }
    },

    beforeDestroy() {
      document.removeEventListener("acbrReply", this.acbrReply);
    },
  }
</script>

<style scoped>
  .product {
    position: relative;
  }

  .product-body {
    background-color: var(--light);
  }

  .product-body a {
    color: var(--dark);
  }

  .product-body .img-produto {
    max-width: 100%;
    margin-left: 6px;
    width: 52px;
    height: 52px;
    object-fit: cover;
    float: right;
    border-radius: 6px;
  }

  .product-body .img-pizza {
    background-color: #ffffff;

  }

  .product.selected .product-body, .product.selected a {
    background-color: var(--primary);
    color: white;
  }

  .product.selected .btn {
    color: white;
  }

  .product-body .tamanho-7, .product-body .tamanho-6 {
    width: 25%;
    height: 25%;
  }

  .product-body .tamanho-9 {
    width: 20%;
    height: 20%;
  }

  .product-body input {
    height: 26px;
  }

  #listaProdutos:focus {
    outline: none;
  }

  .height-95.col-categorias {
    height: calc(100vh - 198px);
    padding-bottom: 8px;
  }

  .height-100.col-produtos {
    height: calc(100vh - 136px);
  }

  .height-95.col-divisoes {
    height: calc(100vh - 198px);
    padding-bottom: 8px;
  }

  @media (min-width: 992px) {
    .height-100.col-produtos {
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
</style>
